import { IBAN } from './iban';
import { z } from 'zod';

export const UserSettings = z.object({
    /** User language */
    language: z.string().nullish(),
    /** Send emails concerning user's own receipts and trips */
    notifyOwnEmail: z.boolean().nullish(),
    /** Send emails concerning user's role */
    notifyRoleEmail: z.boolean().nullish(),
    /** Send email/notifications users do the change themselves */
    notifySelf: z.boolean().nullish(),
    /** Last used country code to be used as default value */
    lastCountryCode: z.string().nullish(),
    /** Should paid items be marked as done automatically? */
    autoArchive: z.boolean().nullish(),
    /** User IBAN */
    iban: IBAN.nullish().catch(null),
    /** Name of the payment recipient */
    paymentRecipient: z.string().nullish(),
});
export type UserSettings = z.infer<typeof UserSettings>;
